import React from 'react';
import {render} from 'react-dom'
import './css/index.css';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css'


function main() {
  const target = document.getElementById('root');
  render((
    <div style={{ height:"100%"}}>
      { router }
    </div>
  ),target);
}

main();



// WEBPACK FOOTER //
// ./src/index.js